
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Adresse from '@/extend/classes/Adresse';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeAdresse' })

export default class storeAdresse extends VuexModule {
  // States
  private reccords: Adresse[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get adresseLoading (): boolean {
    return this.dataLoading;
  }
  private get adresseRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get adresseLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewAdresse() {
    return (): Adresse => { 
      return this.getAdresse(0, true);
    }
  }

  
  public get getAdresse () {
    return (id: number, canCreate = false): Adresse => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Adresse can't be 0")
        return new Adresse();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Adresse();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Adresse.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromAdresse(data.reccords[0] as Adresse);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listAdresse (): Adresse[] {
    return this.reccords;
  }

  public get listConfigAdresse (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mAdresseRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mAdresseClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mAdresseLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mAdresseLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Adresse.fromJson(reccord as Adresse));
    })
    Adresse.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mAdresseConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mAdresseCreated (obj: Adresse): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAdresse(obj)) {
          api.fromAdresse(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareAdresse(obj)) {
            api.fromAdresse(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mAdresseUpdated (obj: Adresse): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareAdresse(obj)) {
          api.fromAdresse(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mAdresseDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerAdresse (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.adresseRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerAdresse(this.adresseCreated, this.adresseUpdated, this.adresseDeleted);
          this.mAdresseRegistered();
        } else {
          setTimeout(() => resolve(this.registerAdresse(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.adresseLoading && !this.adresseLoaded) {
          this.mAdresseLoading(true);
          return Adresse.list(filter)
            .then((data: ListData) => {
              this.mAdresseLoaded(data);
              this.mAdresseLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredAdresse (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.adresseLoading) {
        this.mAdresseLoading(true);
        return Adresse.list(filter)
          .then((data: ListData) => {
            this.mAdresseLoaded(data);
            this.mAdresseLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createAdresse (obj: Adresse): Promise<Adresse> {
    return new Promise((resolve, reject) => {
      return Adresse.fromJson(obj).createForStoreAdresse()
        .then((reccords) => {
          this.mAdresseCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateAdresse (obj: Adresse): Promise<Adresse> {
    return new Promise((resolve, reject) => {
      return Adresse.fromJson(obj).updateForStoreAdresse()
        .then((reccords) => {
          this.mAdresseUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteAdresse (obj: Adresse): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Adresse.fromJson(obj).deleteForStoreAdresse()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mAdresseDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private adresseCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAdresseConfigUpdated(config)
    const obj = objConfig.obj as Adresse;
    this.mAdresseCreated(Adresse.fromJson(obj));
  }

  @Action
  private adresseUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mAdresseConfigUpdated(config)
    const obj = objConfig.obj as Adresse;
    this.mAdresseUpdated(Adresse.fromJson(obj));
  }

  @Action
  private adresseDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Adresse;
    this.mAdresseDeleted(obj.id);
  }
}
